import { X } from 'lucide-react';

import { MockLuminaire } from '../../../types/analytics';
import { LuminaireList } from './LuminaireList';

interface LuminairePickerModalProps {
  open: boolean;
  onClose: () => void;
  luminaires: MockLuminaire[];
  slotAId: string | null;
  slotBId: string | null;
  targetSlot: 'A' | 'B';
  onPick: (luminaire: MockLuminaire) => void;
}

export const LuminairePickerModal = ({
  open,
  onClose,
  luminaires,
  slotAId,
  slotBId,
  targetSlot,
  onPick,
}: LuminairePickerModalProps) => {
  if (!open) return null;
  const isFilled = targetSlot === 'A';
  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40" onClick={onClose} />
      <div className="fixed inset-x-4 inset-y-8 md:inset-x-auto md:left-1/2 md:-translate-x-1/2 md:top-16 md:bottom-16 md:w-[600px] bg-greyP5 border border-greyP4 rounded-2xl z-50 flex flex-col overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between px-5 py-4 border-b border-greyP4">
          <div className="flex items-center gap-3">
            <div
              className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm border-2 border-green01 ${
                isFilled ? 'bg-green01 text-black' : 'bg-transparent text-green01'
              }`}
            >
              {targetSlot}
            </div>
            <div>
              <h3 className="text-white text-base font-semibold">Pick a luminaire for Slot {targetSlot}</h3>
              <p className="text-greyP2 text-[11px]">Search, filter, and sort your catalog</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-9 h-9 rounded-full hover:bg-greyP4 flex items-center justify-center text-greyP2 hover:text-white transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-hidden">
          <LuminaireList
            luminaires={luminaires}
            slotAId={slotAId}
            slotBId={slotBId}
            onPick={(l) => {
              onPick(l);
              onClose();
            }}
          />
        </div>
      </div>
    </>
  );
};
